// src/utils/filtres.js
// ─────────────────────────────────────────────────────────────
// Filtres communs aux pages « Stats Application » et « Stats Jeux »
// (mêmes règles que la page Classements) : années scolaires du 25 août
// au 24 août comme Play & Learn, jeux Accounting, listes Campus →
// Programme → Groupe limitées aux valeurs présentes.
// ─────────────────────────────────────────────────────────────

export const NUMEROS_JEUX = {
  "1 - Cupcakes Battle": 11,
  "2 - Find the Balance": 12,
  "3 - What a bun!": 13,
  "4 - Crazy Coo-Quiz Accounting": 14,
  "5 - Crazy Coo-Quiz Financial Analysis": 15,
}
export const NOMS_JEUX = Object.fromEntries(Object.entries(NUMEROS_JEUX).map(([nom, num]) => [num, nom]))
export const LISTE_JEUX = ["Tous", ...Object.keys(NUMEROS_JEUX)]

/** "2 - Find the Balance" → 12 ; "Tous" → null */
export const jeuVersNum = (libelle) => NUMEROS_JEUX[libelle] ?? null

/** Année scolaire en cours (début) : du 25 août au 24 août. */
export const debutAnneeScolaire = (d = new Date()) =>
  (d.getMonth() > 7 || (d.getMonth() === 7 && d.getDate() >= 25)) ? d.getFullYear() : d.getFullYear() - 1

/** "2026-2027" pour l'année en cours (filtre par défaut de Play & Learn). */
export const anneeEnCours = () => `${debutAnneeScolaire()}-${debutAnneeScolaire() + 1}`

/** Premières données Accounting : février 2025 (année 2024-2025). */
const PREMIERE_ANNEE = 2024

export const optionsAnnees = () => {
  const options = ["Tous"]
  for (let a = PREMIERE_ANNEE; a <= debutAnneeScolaire(); a++) options.push(`${a}-${a + 1}`)
  return options
}

/** "2026-10-04" / "2026-10-04 21:05:00" / "2025-02-12T18:31:19." → Date (jour), sinon null */
export const jourDe = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null
  const p = dateStr.slice(0, 10).split("-")
  if (p.length < 3) return null
  const d = new Date(+p[0], (+p[1]) - 1, +p[2])
  return isNaN(d) ? null : d
}

/** La date tombe-t-elle dans l'année scolaire « 2026-2027 » ? « Tous » : toujours. */
export const dansAnnee = (dateStr, annee) => {
  if (!annee || annee === "Tous") return true
  const d = jourDe(dateStr)
  if (!d) return false
  const a = parseInt(annee.split("-")[0], 10)
  return d >= new Date(a, 7, 25) && d <= new Date(a + 1, 7, 24)
}

export const estRenseigne = (v) => v !== null && v !== undefined && String(v).trim() !== ""

// Comparaison en texte : une même valeur peut arriver en nombre ou en texte
// (groupe « 3 », pseudo « 16 »).
export const memeValeur = (a, b) => String(a ?? "").trim() === String(b ?? "").trim()

export const valeursUniques = (lignes, attribut) => {
  const valeurs = [...new Set(lignes.map((l) => l[attribut]).filter(estRenseigne).map((v) => String(v).trim()))]
    .sort((a, b) => String(a).localeCompare(String(b)))
  return ["Tous", ...valeurs]
}

/**
 * Cascade Campus → Programme → Groupe → Nom / Prénom / Pseudo sur des lignes
 * déjà filtrées par année (et par jeu). Renvoie les options de chaque liste
 * et les lignes retenues par tous les filtres.
 */
export const appliquerFiltres = (lignes, f) => {
  const lignesCampus = lignes.filter((l) => f.campus === "Tous" || memeValeur(l.campus, f.campus))
  const lignesProgramme = lignesCampus.filter((l) => f.programme === "Tous" || memeValeur(l.programme, f.programme))
  const lignesGroupe = lignesProgramme.filter((l) => f.groupe === "Tous" || memeValeur(l.groupe, f.groupe))
  const retenues = lignesGroupe
    .filter((l) => f.nom === "Tous" || memeValeur(l.nom, f.nom))
    .filter((l) => f.prenom === "Tous" || memeValeur(l.prenom, f.prenom))
    .filter((l) => f.pseudo === "Tous" || memeValeur(l.pseudo, f.pseudo))
  return {
    options: {
      campus: valeursUniques(lignes, "campus"),
      programme: valeursUniques(lignesCampus, "programme"),
      groupe: valeursUniques(lignesProgramme, "groupe"),
      nom: valeursUniques(lignesGroupe, "nom"),
      prenom: valeursUniques(lignesGroupe.filter((l) => f.nom === "Tous" || memeValeur(l.nom, f.nom)), "prenom"),
      pseudo: valeursUniques(lignesGroupe, "pseudo"),
    },
    retenues,
  }
}
